import axios from 'axios';
import { compressImage } from '../utils/compressImage';

const BASE     = `${process.env.REACT_APP_BACKEND_URL}/api/supplier`;
const ADMIN    = `${process.env.REACT_APP_BACKEND_URL}/api/ultra-admin`;

const auth = () => {
  // Ultra Admin path'indeyken her zaman ultra token kullan
  // Bu, eski/geçersiz cop31_supplier_token'ın öncelik almasını engeller
  const isUltraPath = window.location.pathname.startsWith('/ultra-admin');
  const token = isUltraPath
    ? (localStorage.getItem('cop31_ultra_token') || '')
    : (localStorage.getItem('cop31_supplier_token') || localStorage.getItem('cop31_ultra_token') || '');
  return { headers: { Authorization: `Bearer ${token}` } };
};
const multipart = () => ({
  headers: { ...auth().headers, 'Content-Type': 'multipart/form-data' },
});

// ── Stats ────────────────────────────────────────────────────────────────────
export const fetchStats    = () => axios.get(`${BASE}/stats`, auth()).then(r => r.data);

// ── Profile ──────────────────────────────────────────────────────────────────
export const fetchProfile  = () => axios.get(`${BASE}/profile`, auth()).then(r => r.data);
export const updateProfile = (data) => axios.put(`${BASE}/profile`, data, auth()).then(r => r.data);
export const uploadLogo    = async (file) => {
  const fd = new FormData(); fd.append('logo', await compressImage(file));
  return axios.post(`${BASE}/profile/logo`, fd, multipart()).then(r => r.data);
};

// ── Categories ────────────────────────────────────────────────────────────────
export const fetchCategories = () => axios.get(`${BASE}/categories`, auth()).then(r => r.data);

// ── Units ─────────────────────────────────────────────────────────────────────
export const fetchUnits = () => axios.get(`${BASE}/units`, auth()).then(r => r.data);

// ── Products ──────────────────────────────────────────────────────────────────
export const fetchProducts      = (params = {}) => axios.get(`${BASE}/products`, { ...auth(), params }).then(r => r.data);
export const fetchProduct       = (id) => axios.get(`${BASE}/products/${id}`, auth()).then(r => r.data);
export const createProduct      = (data) => axios.post(`${BASE}/products`, data, auth()).then(r => r.data);
export const updateProduct      = (id, data) => axios.put(`${BASE}/products/${id}`, data, auth()).then(r => r.data);
export const deleteProduct      = (id) => axios.delete(`${BASE}/products/${id}`, auth()).then(r => r.data);
export const restoreProduct     = (id) => axios.post(`${BASE}/products/${id}/restore`, {}, auth()).then(r => r.data);
export const duplicateProduct   = (id) => axios.post(`${BASE}/products/${id}/duplicate`, {}, auth()).then(r => r.data);

export const uploadProductImage = async (productId, file, onProgress) => {
  const fd = new FormData(); fd.append('image', await compressImage(file));
  return axios.post(`${BASE}/products/${productId}/images`, fd, {
    ...multipart(),
    onUploadProgress: onProgress ? (e) => onProgress(Math.round((e.loaded * 100) / e.total)) : undefined,
  }).then(r => r.data);
};
export const deleteImage        = (imageId) => axios.delete(`${BASE}/images/${imageId}`, auth()).then(r => r.data);
export const setCoverImage      = (imageId) => axios.put(`${BASE}/images/${imageId}/set-cover`, {}, auth()).then(r => r.data);
export const reorderImages      = (imageIds) => axios.post(`${BASE}/images/reorder`, { image_ids: imageIds }, auth()).then(r => r.data);

// ── Product Variants ──────────────────────────────────────────────────────────
export const fetchVariants      = (productId) => axios.get(`${BASE}/products/${productId}/variants`, auth()).then(r => r.data);
export const createVariant      = (productId, data) => axios.post(`${BASE}/products/${productId}/variants`, data, auth()).then(r => r.data);
export const updateVariant      = (variantId, data) => axios.put(`${BASE}/variants/${variantId}`, data, auth()).then(r => r.data);
export const deleteVariant      = (variantId) => axios.delete(`${BASE}/variants/${variantId}`, auth()).then(r => r.data);
export const checkAvailability  = (productId, qty, pricingType) =>
  axios.post(`${BASE}/products/${productId}/check-availability`, { quantity: qty, pricing_type: pricingType }, auth()).then(r => r.data);

export const uploadVariantImage = async (variantId, productId, file, onProgress) => {
  const fd = new FormData(); fd.append('image', await compressImage(file)); fd.append('variant_id', variantId);
  return axios.post(`${BASE}/products/${productId}/images`, fd, {
    ...multipart(),
    onUploadProgress: onProgress ? (e) => onProgress(Math.round((e.loaded * 100) / e.total)) : undefined,
  }).then(r => r.data);
};

// ── Services ──────────────────────────────────────────────────────────────────
export const fetchServices      = (params = {}) => axios.get(`${BASE}/services`, { ...auth(), params }).then(r => r.data);
export const createService      = (data) => axios.post(`${BASE}/services`, data, auth()).then(r => r.data);
export const updateService      = (id, data) => axios.put(`${BASE}/services/${id}`, data, auth()).then(r => r.data);
export const deleteService      = (id) => axios.delete(`${BASE}/services/${id}`, auth()).then(r => r.data);
export const restoreService     = (id) => axios.post(`${BASE}/services/${id}/restore`, {}, auth()).then(r => r.data);

export const uploadServiceImage = async (serviceId, file) => {
  const fd = new FormData(); fd.append('image', await compressImage(file));
  return axios.post(`${BASE}/services/${serviceId}/images`, fd, multipart()).then(r => r.data);
};

// ── Orders ────────────────────────────────────────────────────────────────────
export const fetchOrders        = (params = {}) => axios.get(`${BASE}/orders`, { ...auth(), params }).then(r => r.data);
export const fetchOrder         = (id) => axios.get(`${BASE}/orders/${id}`, auth()).then(r => r.data);
export const updateOrderStatus  = (id, status, supplierNotes) =>
  axios.put(`${BASE}/orders/${id}/status`, { status, supplier_notes: supplierNotes }, auth()).then(r => r.data);
export const updateOrderNotes   = (id, supplierNotes) =>
  axios.put(`${BASE}/orders/${id}/notes`, { supplier_notes: supplierNotes }, auth()).then(r => r.data);
export const submitQuote        = (id, quoteData) =>
  axios.post(`${BASE}/orders/${id}/quote`, quoteData, auth()).then(r => r.data);

// ── Documents ─────────────────────────────────────────────────────────────────
export const fetchDocuments     = () => axios.get(`${BASE}/documents`, auth()).then(r => r.data);
export const uploadDocument     = (fd) => axios.post(`${BASE}/documents`, fd, multipart()).then(r => r.data);
export const deleteDocument     = (id) => axios.delete(`${BASE}/documents/${id}`, auth()).then(r => r.data);

// ── Media URL Refresh (called on image load failure / URL expiry) ──────────────
export const refreshMediaUrls = (imageIds) =>
  axios.post(`${BASE}/media/refresh-urls`, { image_ids: imageIds }, auth()).then(r => r.data);

// ── Ultra Admin: Units management ─────────────────────────────────────────────
export const adminFetchUnits    = () => axios.get(`${ADMIN}/units`, auth()).then(r => r.data);
export const adminCreateUnit    = (data) => axios.post(`${ADMIN}/units`, data, auth()).then(r => r.data);
export const adminUpdateUnit    = (id, data) => axios.put(`${ADMIN}/units/${id}`, data, auth()).then(r => r.data);
export const adminDeleteUnit    = (id) => axios.delete(`${ADMIN}/units/${id}`, auth()).then(r => r.data);
